import { render, staticRenderFns } from "./UserLoginHandler.vue?vue&type=template&id=16c6d3ed&"
import script from "./UserLoginHandler.vue?vue&type=script&lang=js&"
export * from "./UserLoginHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c6d3ed')) {
      api.createRecord('16c6d3ed', component.options)
    } else {
      api.reload('16c6d3ed', component.options)
    }
    module.hot.accept("./UserLoginHandler.vue?vue&type=template&id=16c6d3ed&", function () {
      api.rerender('16c6d3ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/UserLoginHandler.vue"
export default component.exports